<script setup lang="ts">
import InputNumber from '@/components/input-number.vue';
import { AssetType } from '@/features/assets/constants';
import InvoiceSkeletonPlaceholderText from '@/features/invoices/components/partials/InvoiceSkeletonPlaceholderText.vue'
import { format } from 'date-fns/format'

defineProps<{ invoiceNumber?: string, date?: Date, dateFormat: string, period?: [Date, Date], assetType?: AssetType, isManualInvoice: boolean }>()
const recsGenerated = defineModel<number>('recsGenerated')
</script>

<template>
  <div :class="$style.wrapper" class="d-grid">
    <span>Invoice Number</span>
    <span>
      <template v-if="invoiceNumber">{{ invoiceNumber }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span>Invoice Date</span>
    <span>
      <template v-if="date">{{ format(date, dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span v-if="!isManualInvoice || period">Invoice Period</span>
    <span v-if="!isManualInvoice || period">
      <template v-if="period">{{ format(period[0], dateFormat) }} - {{ format(period[1], dateFormat) }}</template>
      <InvoiceSkeletonPlaceholderText v-else />
    </span>

    <span v-if="assetType === AssetType.Wheeling">REC's Generated</span>
    <span v-if="assetType === AssetType.Wheeling">
      <InputNumber v-model:value="recsGenerated" />
    </span>
  </div>
</template>

<style module lang="scss">
.wrapper {
  grid-template-columns: 1fr 1fr;
}
</style>
